module.exports = __webpack_public_path__ + "img/q1.8fce6b24.svg";